var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLyfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.88px)",
      clipPath: "url(#bgblur_0_11221_19673_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 7.76652,
    width: 50,
    height: 50,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9098 41V35H18.9555V39.9543H21.4541V41H17.9098ZM22.6964 41V35H23.7421V41H22.6964ZM25.0746 41V35H28.6189V36.0457H26.1203V37.2629H28.2075V38.3086H26.1203V41H25.0746ZM29.4146 41V35H33.1774V36.0457H30.4603V37.2629H32.616V38.3086H30.4603V39.9543H33.1774V41H29.4146Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2663 11.844C25.2663 11.844 29.8719 7.95186 33.5638 11.4768C36.7073 14.4877 35.7569 19.0775 32.2113 23.0063C28.556 27.0453 25.2663 28 25.2663 28C25.2663 28 21.94 27.0453 18.2847 23.0063C14.7025 19.0775 13.7522 14.4877 16.9322 11.4768C20.6606 7.95186 25.2663 11.844 25.2663 11.844Z",
    fill: "#DA837D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4722 15.0022C26.7562 15.0138 27.0201 15.1509 27.1929 15.3811L29.0054 17.7981H30.6265C31.1504 17.7981 31.5757 18.2234 31.5757 18.7473C31.5756 19.2712 31.1504 19.6965 30.6265 19.6965H28.5308C28.2695 19.6965 28.0202 19.5893 27.8423 19.4016L27.771 19.3167L26.5952 17.7483L24.4878 21.968V21.969C24.3406 22.2617 24.0532 22.4584 23.7261 22.4885L23.7271 22.4895C23.6954 22.4927 23.6654 22.4934 23.6392 22.4934C23.3792 22.4934 23.1303 22.387 22.9517 22.1995L22.8804 22.1135L21.0688 19.6965H19.4468C18.9229 19.6965 18.4976 19.2712 18.4976 18.7473C18.4976 18.2234 18.9228 17.7981 19.4468 17.7981H21.5425C21.8413 17.7981 22.122 17.9389 22.3013 18.178L23.4761 19.7454L25.5854 15.5256L25.647 15.4202C25.8054 15.1854 26.0621 15.0309 26.3491 15.0051H26.3501L26.4722 15.0022Z",
    fill: "white",
    stroke: "#DA837D",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11221_19673_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyfLogo);
export default __webpack_public_path__ + "static/media/lyfLogo.42f20930f6dc544911b0c5c4d60e4db2.svg";
export { ForwardRef as ReactComponent };